import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_DEVICES } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const getChargingDeviceListAPI: any = createAsyncThunk(
  "getChargingDeviceList",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);

    try {
      const res = await axios.get(CHARGING_DEVICES, {
        // headers: {
        //   // istoken: "false",
        //   token : JSON.parse(token)
        // },
        headers: commonHead,
        params: params,
      });
      return { device: res };
    } catch (error: any) {
      // if (error instanceof Error) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
      // }
    }
  }
);
